module.exports = __webpack_public_path__ + "img/honor3.2f7ba3d1.png";